import React, { useEffect, useState } from "react";
import "./styles.scss";

import { PaymentElement } from "@stripe/react-stripe-js";
import { useElements } from "@stripe/react-stripe-js";
import { useStripe } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../../store";

const PaymentInfo = ({ handleSubmitCall, setHandleSubmitCall }) => {
  const stripe = useStripe();
  const elements = useElements();
  const Navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [{}, dispatch] = useStateValue();

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setHandleSubmitCall(false);
    sessionStorage.setItem("payment_intent", "");
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });
    if (!stripe || !elements) {
      return;
    }
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url:
          window.location.origin + process.env.REACT_APP_BASE + "/order-status",
      },
      // redirect: "if_required",
    });
    if (error) {
      setMessage(error?.message);
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
    }
    //  else if (!error?.status && error?.payment_intent?.id) {
    //   sessionStorage.setItem("payment_intent", error?.payment_intent?.id);
    //   setTimeout(() => {
    //     dispatch({
    //       type: "SET_IS_LOADING",
    //       value: false,
    //     });
    //     Navigate(`${process.env.REACT_APP_BASE}/order-status`);
    //   }, 1000);
    // }
  };

  useEffect(() => {
    if (handleSubmitCall) {
      setMessage("");
      handleSubmit();
    }
  }, [handleSubmitCall]);

  return (
    <form
      className="payment-container"
      id="payment-form"
      onSubmit={handleSubmit}
    >
      <PaymentElement
        id="payment-element"
        options={{ layout: "tabs" }}
        onChange={(e) => setMessage("")}
      />
      {/* Show any error or success messages */}
      {message && (
        <div
          id="payment-message"
          style={{
            padding: "1rem 0 1rem 0",
            color: "red",
            fontSize: "12px",
          }}
        >
          {message}
        </div>
      )}
    </form>
  );
};

export default PaymentInfo;
